import awards from "../../shared/la.awards";
import branded_quotes from "../../shared/la.branded-quotes";
import verticals from "./la-education-primary.verticals";

const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};

export default ({ page, strings }) => {
    switch (page) {
        case "la-education-primary-404":
            return {
                page,
                helmet: {
                    meta_title: "Sitio no encontrado | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://espanol.rosettastone.com/educacion-basica/404",
                    lang: "es"
                },
                ...pageFooter({ strings })
            };
        case "la-education-primary-contact":
            return {
                page,
                helmet: {
                    meta_title: "Contacto | Rosetta Stone",
                    meta_description:
                        "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                    canonical_url: "https://espanol.rosettastone.com/educacion-basica/contacto/",
                    lang: "es"
                },
                ...pageFooter({ strings })
            };
        case "la-education-primary-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "es"
                },
                ...pageFooter({ strings })
            };
        case "la-education-primary-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "es"
                },
                ...pageFooter({ strings })
            };
        case "la-education-primary-home":
            return {
                page,
                helmet: {
                    meta_title: "Aprendizaje de Idiomas en línea para K-12 | Rosetta Stone",
                    meta_description:
                        "Las soluciones para el aprendizaje de idiomas K-12 de Rosetta Stone se fusionan con la instrucción del profesor en el salón de clase y el acceso en cualquier momento en que los estudiantes deseen aprender o mejorar su conocimiento del idioma inglés o su competencia lingüística a nivel mundial.  ",
                    canonical_url: "https://espanol.rosettastone.com/educacion-basica/",
                    lang: "es"
                },
                ...pageFooter({ strings })
            };
        case "la-education-primary-solutions":
            return {
                page,
                helmet: {
                    meta_title: "Programas de Aprendizaje de Idiomas K-12 en línea | Rosetta Stone",
                    meta_description:
                        "Los programas de aprendizaje de idiomas de Rosetta Stone motivan a los estudiantes del idioma inglés y de los idiomas del mundo a hablar con confianza y seguridad. Pregunte sobre nuestros precios.",
                    canonical_url: "https://espanol.rosettastone.com/educacion-basica/soluciones/",
                    lang: "es"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
